import { useState, useEffect } from "react";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useContactsView = ({ pageNumber, filter, selectedConnectionIds }) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [contactsView, setContactsView] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    setLoading(true);

    const delayDebounceFn = setTimeout(() => {
      const fetchContactsView = async() => {
        try {
          const { data } = await api.get("/contactsView", { params: { pageNumber, filter, selectedConnectionIds }, })

          setContactsView(data.contactsView);
          setHasMore(data.hasMore)
          setCount(data.count)
          setLoading(false)
        } catch (exception) {
          setLoading(false)
          console.log("Use Contacts View Exception:", exception);
          toastError(exception)
        }
      }

      fetchContactsView();
    }, 500);

    return () => clearTimeout(delayDebounceFn)
  }, [pageNumber, filter, selectedConnectionIds])

  return { contactsView, loading, hasMore, count };
};

export default useContactsView;